export default {
  api: {
    queryConsumptionOfYear: {
      method: "get",
      url: "/home/queryConsumptionOfYear"
    }
  }
};
